import * as React from 'react';

function SvgFaq(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M17.8 6.714a1.821 1.821 0 01-.838 1.366c-.134.112-.383.318-.382.394a.536.536 0 01-.54.541.537.537 0 01-.544-.532 1.63 1.63 0 01.771-1.233c.271-.228.449-.388.449-.535a.539.539 0 00-1.077 0 .544.544 0 11-1.089 0 1.627 1.627 0 013.254 0zm-1.75 2.8a.534.534 0 00-.532.544.532.532 0 00.532.542.545.545 0 000-1.091zM5.076 13.309a.544.544 0 100 1.089h.045a.544.544 0 100-1.089zm1.892 0a.544.544 0 100 1.089h.045a.544.544 0 100-1.089zm15.986-8.693v6.127a2.617 2.617 0 01-2.614 2.628H12.679c-.046.03-.157.133-.265.232l-.143.13-2 1.82a.557.557 0 01-.928-.4V9.378h-5.7a1.56 1.56 0 00-1.554 1.548v6.127a1.536 1.536 0 001.556 1.519h7.885a.546.546 0 01.363.154l1.627 1.5v-5.174a.544.544 0 011.089 0v6.407a.537.537 0 01-.321.5.522.522 0 01-.216.043.55.55 0 01-.367-.148l-2.386-2.19H3.644A2.625 2.625 0 011 17.052v-6.126A2.65 2.65 0 013.644 8.29h5.7V4.616A2.64 2.64 0 0112 2h8.34a2.606 2.606 0 012.614 2.616zm-1.089 0a1.517 1.517 0 00-1.525-1.527H12a1.55 1.55 0 00-1.565 1.527v9.3l1.094-.989c.051-.046.107-.089.149-.127a1.374 1.374 0 011.279-.521h7.383a1.527 1.527 0 001.525-1.539V4.616z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgFaq;
